/// <amd-module name="Reporting/Visuals/VisualMessages/WrappedVisualImage" />
import * as React from "react";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { IImageProps, Image } from "VSSUI/Image";

export interface ImageProps {
    imagePath: string;
    includeDependencies: string[];
    width?: number;
    height?: number;
    containImage?: boolean;
    altText?: string;
}

/** Wraps usage of an Image, so consumers don't need to make direct reference to shared-data paths of this project.
 */
export class WrappedVisualImage extends VssComponent<ImageProps, {}> {
    public render(): JSX.Element {
        return (
            <WrappedComponent
                wrappedType={ImageComponent.componentType}
                dependencies={this.props.includeDependencies || []}
                wrappedProps={this.props}
            />
        );
    }
}

class ImageComponent extends VssComponent<ImageProps, {}> {
    public static componentType: string = "imageComponent";
    public render(): JSX.Element {
        return <Image {...this.getImageProps()} />;
    }

    public getImageProps(): IImageProps {
        // Note: This step looks up paths which are consumed via WrappedComponent step. Otherwise, this component is completely vanilla.
        const assetLocation = getAssetLocation(this.context.pageContext, this.props.imagePath);

        return {
            src: assetLocation,
            width: this.props.width,
            height: this.props.height,
            containImage: this.props.containImage,
            alt: this.props.altText
        } as IImageProps;
    }
}
VssComponent.register(ImageComponent.componentType, ImageComponent);
